<div
  #container
  class="fw-container"
  [ngStyle]="{
    transform: 'translate(' + x + 'px,' + y + 'px)',
    width: width + 'px',
    height: height + 'px'
  }"
>
  <div class="fw-header" (pointerdown)="onHeaderPointerDown($event)">
    <div class="fw-title">Encounter Documents</div>

    <div class="fw-actions">
      <button type="button" class="fw-btn" (click)="close()" aria-label="Close">
        ✕
      </button>
    </div>
  </div>

  <div class="fw-body">
    <iframe class="fw-iframe" [src]="iframeUrl" loading="lazy" allow="clipboard-read; clipboard-write"></iframe>
  </div>

  <!-- Resize handles -->
  <div class="fw-resize fw-resize-e" (pointerdown)="onResizePointerDown($event, 'e')"></div>
  <div class="fw-resize fw-resize-s" (pointerdown)="onResizePointerDown($event, 's')"></div>
  <div class="fw-resize fw-resize-se" (pointerdown)="onResizePointerDown($event, 'se')"></div>
</div>
